import { CdkScrollable } from '@angular/cdk/scrolling';
import { ChangeDetectionStrategy, Component, computed, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GuidelineService, GuidelineViewService, MessagesService, provideGuideline, TreeScrollService, UserService } from 'shared/domain';
import {
  DrawerComponent,
  DrawerContainerComponent,
  DrawerContentComponent,
  DrawerRightDirective,
  SpinnerComponent,
} from 'shared/ui-common';

import { SmartbookContentComponent } from '../../../../guideline-page/src/lib/guideline-view/content/content.component';
import { SmartbookFooterComponent } from '../../../../guideline-page/src/lib/guideline-view/footer/smartbook-footer.component';
import { MainSidebarComponent } from '../../../../shared/feature-main-sidebar/src/lib/main-sidebar.component';
import { IndexedDbService } from '../../../../shared/util-common/src/lib/services/indexed-db.service';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'tt-offline-guideline-view',
  templateUrl: './offline-guideline-view.component.html',
  styleUrls: ['./offline-guideline-view.component.scss'],
  imports: [
    SpinnerComponent,
    CdkScrollable,
    DrawerComponent,
    DrawerContainerComponent,
    DrawerContentComponent,
    DrawerRightDirective,
    MainSidebarComponent,
    SmartbookContentComponent,
    SmartbookFooterComponent,
  ],
  providers: [provideGuideline(), TreeScrollService, GuidelineViewService],
})
export class OfflineGuidelineViewComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private indexedDbService = inject(IndexedDbService);
  private messagesService = inject(MessagesService);
  protected guidelineService = inject(GuidelineService);
  private userService = inject(UserService);

  protected loading = computed(() => !this.guidelineService.guidelineData());

  public async ngOnInit() {
    const guidelineId = this.route.snapshot.paramMap.get('id');

    if (guidelineId) {
      try {
        const guideline = await this.indexedDbService.getGuidelineByUniqueId(this.userService.user().id, guidelineId);
        this.guidelineService.setGuideline(guideline);
      } catch (error) {
        this.messagesService.showError(undefined, error);

        await this.router.navigate(['/offline']);
      }
    }
  }
}
